"use client";

import Script from "next/script";
import { useShouldShowAds } from "./ads/AdsProvider";

export default function AdsScript() {
  const shouldShowAds = useShouldShowAds();

  if (!shouldShowAds) return null;

  return (
    <Script
      id="google-adsense"
      async
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9143210451390429"
      crossOrigin="anonymous"
      strategy="lazyOnload"
    ></Script>
  );
}
